import { render, staticRenderFns } from "./StoreManagement.vue?vue&type=template&id=8d07b738&scoped=true&"
import script from "./StoreManagement.vue?vue&type=script&lang=js&"
export * from "./StoreManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d07b738",
  null
  
)

export default component.exports